import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import {
  ConversionRate,
  ConversionRateListParams,
  CreateConversionRate
} from '~core/models/conversion-rate.models';
import { ApiConstantsService } from './api-constants.service';
import { Pagination } from '~core/models/core.models';

@Injectable()
export class ConversionRateService {
  private _httpClient = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  readonly apiUrl = this._apiConstantsService.conversionRatesUrl;

  list(
    params: ConversionRateListParams
  ): Observable<Pagination<ConversionRate>> {
    return this._httpClient.get<Pagination<ConversionRate>>(this.apiUrl, {
      params: {
        ...params,
        sort: params?.sort || 'createdAt',
        desc: params?.desc || 'createdAt'
      } as Record<string, any>
    });
  }

  read(conversionRateId: string): Observable<ConversionRate> {
    return this._httpClient.get<ConversionRate>(
      `${this.apiUrl}/${conversionRateId}`
    );
  }

  create(params: CreateConversionRate): Observable<ConversionRate> {
    return this._httpClient.post<ConversionRate>(this.apiUrl, params);
  }

  update(
    conversionRateId: string,
    params: Partial<CreateConversionRate>
  ): Observable<ConversionRate> {
    return this._httpClient.patch<ConversionRate>(
      `${this.apiUrl}/${conversionRateId}`,
      params
    );
  }

  delete(conversionRateId: string): Observable<void> {
    return this._httpClient.delete<void>(`${this.apiUrl}/${conversionRateId}`);
  }
}
